import * as React from 'react';
import styled from 'react-emotion';
import posed from 'react-pose';
/**
 * A component that can be optionally used as the accordion's content to
 * automatically apply open animations.
 */
export const AccordionContent = props => (React.createElement(PosedAccordionItem, { pose: props.isOpen ? 'opened' : 'closed', initialPose: "closed" }, props.children));
export default class Accordion extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            openIndexes: (this.props.initialOpenIndexes || [this.props.atLeastOne && 0]).filter(el => isFinite(el))
        };
        this.close = (index) => {
            this.setState(prevState => {
                const openCount = prevState.openIndexes.length;
                return {
                    openIndexes: this.props.atLeastOne &&
                        openCount === 1 &&
                        prevState.openIndexes.includes(index)
                        ? prevState.openIndexes
                        : prevState.openIndexes.filter(i => i !== index)
                };
            });
        };
        this.open = (index) => {
            this.setState(prevState => {
                const openIndexes = this.props.single
                    ? [index]
                    : [...prevState.openIndexes, index];
                return {
                    openIndexes
                };
            });
        };
        this.handleItemClick = (index) => {
            // Determine whether we are closing or opening this accordion item
            const action = this.state.openIndexes.includes(index)
                ? 'closing'
                : 'opening';
            if (action === 'closing') {
                this.close(index);
            }
            else {
                this.open(index);
            }
        };
    }
    render() {
        return this.props.children({
            openIndexes: this.state.openIndexes,
            handleClick: this.handleItemClick,
            AccordionContent
        });
    }
}
// For some reason, 'opened' as the key works, but 'open' does not.
const PosedDiv = posed.div({
    opened: {
        height: 'auto'
    },
    closed: {
        height: 0
    }
});
const PosedAccordionItem = styled(PosedDiv) `
  overflow: hidden;
  height: 0;
`;
//# sourceMappingURL=Accordion.js.map